import { useEffect } from "react";
import { useRouter } from "next/router";

import WebViewBridge from "@logics/utils/webViewBridge";
import { NAVIGATION_ROUTE } from "@domains/common/constants/navigationRoute";

// TODO: 클라이언트에서 웹뷰 판단 후 리다이렉팅 시켜주어 데이터가 보이므로 개선 필요

interface UseGuardWebViewProps {
  redirectCallback: () => void;
}

/**
 * 웹뷰에서만 접근 가능하도록 만드는 Hook
 *
 * 웹뷰가 아닌 경우 홈(랜딩 페이지)으로 리다이렉트
 */
export const useGuardWebView = (props?: UseGuardWebViewProps) => {
  const { replace } = useRouter();

  useEffect(() => {
    // NOTE: production 외 환경(develop/test/staging)에서는 웹뷰가 아닌 경우도 허용
    if (process.env.NEXT_PUBLIC_NODE_ENV !== "production") return;

    if (!WebViewBridge.isInAppWebView()) {
      const redirectToHome = () => replace(NAVIGATION_ROUTE.HOME.HREF);
      const replacePage = props?.redirectCallback || redirectToHome;

      replacePage();
    }
  }, [replace, props?.redirectCallback]);
};
